import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16">
            {/* Brand Column */}
            <div>
              <Link to="/" className="font-heading text-2xl font-bold tracking-tight">
                VIGORBUY
              </Link>
              <p className="mt-4 text-foreground-300 text-sm leading-relaxed max-w-xs">
                The most comprehensive VigorBuy spreadsheet with trusted seller lists, QC guides, and weekly updates. Helping thousands shop smarter every day.
              </p>
              <div className="flex items-center gap-4 mt-6">
                <a href="#" className="w-9 h-9 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer" aria-label="Twitter">
                  <i className="ri-twitter-x-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer" aria-label="Instagram">
                  <i className="ri-instagram-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer" aria-label="Reddit">
                  <i className="ri-reddit-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer" aria-label="Discord">
                  <i className="ri-discord-line text-sm"></i>
                </a>
              </div>
            </div>

            {/* Info Column */}
            <div className="space-y-6">
              <div>
                <p className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-2">Address</p>
                <p className="text-sm text-foreground-300 leading-relaxed">
                  123 Commerce Street<br />
                  Suite 456<br />
                  New York, NY 10001
                </p>
              </div>
              <div>
                <p className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-2">Phone</p>
                <p className="text-sm text-foreground-300">+1 (555) 123-4567</p>
              </div>
              <div>
                <p className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-2">Email</p>
                <p className="text-sm text-foreground-300">hello@vigorbuy.quest</p>
              </div>
            </div>

            {/* Image Column */}
            <div className="flex items-start justify-start md:justify-end">
              <div className="w-40 h-48 rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20fashion%20accessories%20and%20a%20smartphone%20displaying%20a%20spreadsheet%20organized%20in%20a%20circular%20composition%20on%20a%20warm%20cork%20board%20surface%2C%20colorful%20sticky%20notes%20and%20pins%20around%20edges%2C%20creative%20planning%20aesthetic%2C%20natural%20afternoon%20light%2C%20editorial%20mood%20board%20photography&width=400&height=480&seq=footer-img-v3&orientation=portrait"
                  alt="VigorBuy Spreadsheet - Creative planning flat lay"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="mt-12 pt-8 border-t border-foreground-700/40 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} VigorBuy. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap">Privacy</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap">Terms</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap">Contact</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}